
import MenuItemModificationUpdateBtn from "./menu-item-modification-update-btn.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    MenuItemModificationUpdateBtn
  },
  data() {
    return {
      isDelayed: false
    };
  },
  computed: {
    ...mapGetters("menu", [
      "getPendingCatalogueSyncItems",
      "getPendingCatalogueSyncAddons",
      "getPendingCatalogueSyncCombos"
    ]),
    getAllPendingSyncs() {
      return [
        ...this.getPendingCatalogueSyncItems,
        ...this.getPendingCatalogueSyncAddons,
        ...this.getPendingCatalogueSyncCombos
      ];
    }
  }
};
